module.exports = __webpack_public_path__ + "img/bgtop.e807eb5d.jpg";